import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  message: {
    marginBottom: theme.spacing(2)
  }
}));

const ascMessageValues = {
  supportLink: (
    <a
      href="https://www.deltek.com/support"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage id="unhandledErrorPage.supportLinkText" />
    </a>
  )
};

const getEventIdValues = eventId => ({ eventId });

export const UnhandledErrorDescription = ({ eventId }) => {
  const classes = useStyles();

  return (
    <>
      <Typography component="p" variant="h6">
        <FormattedMessage id="unhandledErrorPage.description" />
      </Typography>
      <Typography
        className={classes.message}
        component="p"
        variant="body2"
        color="textSecondary"
      >
        <FormattedMessage
          id="unhandledErrorPage.ascMessage"
          values={ascMessageValues}
        />
      </Typography>
      <Typography className={classes.message} component="p" variant="caption">
        <FormattedMessage
          id="unhandledErrorPage.eventId"
          values={getEventIdValues(eventId)}
        />
      </Typography>
    </>
  );
};

UnhandledErrorDescription.propTypes = {
  eventId: PropTypes.string
};

export default UnhandledErrorDescription;
